// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Select
} from '../'

const QUERY_FILETYPES = gql`
  query($language: String!) {
    filetypes(defaultRequesttype_Id_Isnull: false, language: $language) {
      edges {
        node {
          id
          language
          name
          version
          defaultRequesttype {
            id
          }
        }
      }
    }
  }
`


export const FileTypeSelect = ({ fileType, language, onSelect, className }) => {
  if (language) {
    return (
      <Query query={QUERY_FILETYPES} variables={{ language }}>
          {({ loading, error, data}) => {
            if (loading) {
              return (
                <Select
                  label='Select file type'
                  placeholder='Loading options...'
                  value={fileType}
                  options={[]}
                  disabled={true}
                  className={`slds-size_1-of-3 ${className}`}
                />
              )
            }

            if (error) {
              return (
                <Select
                  label='Select file type'
                  placeholder='Error loading options'
                  value={null}
                  options={[]}
                  hasError={true}
                  disabled={true}
                  className={`slds-size_1-of-3 ${className}`}
                />
              )
            }

            let fileTypes = data.filetypes.edges
              .sort((a, b) => {
                if ((a.node.version < b.node.version && a.node.name === b.node.name) ||
                  a.node.name > b.node.name) {
                  return 1
                } else {
                  return -1
                }
              })
              .map(fileType => (
                {
                  value: fileType.node.id,
                  label: `${fileType.node.name} v${fileType.node.version}`
                }
              ))

            return (
              <Select
                id='fileType'
                label='Select file type'
                placeholder='Choose'
                value={fileType}
                options={fileTypes}
                onChange={onSelect}
                className={`slds-size_1-of-3 ${className}`}
              />
            )
          }}
        </Query>
    )
  } else {
    return (
      <Select
        label='Select file type'
        placeholder='Choose language'
        value={null}
        options={[]}
        disabled={true}
        className={`slds-size_1-of-3 ${className}`}
      />
    )
  }
}

FileTypeSelect.propTypes = {
  fileType: PropTypes.string,
  language: PropTypes.string,
  onSelect: PropTypes.func,
  className: PropTypes.string
}

FileTypeSelect.defaultProps = {
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/bulk-file-uploader/FileTypeSelect.js